export const analyticsViewComponentName = 'profileCardNextLegacyView';
